import api from "./API"

export const menuItems = async (data) => {
  try {
    return await api.post(`/fetch-menu`, data)
  } catch (error) {
    console.log(error)
  }
}
